import React, { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, hasCheckedAuth, checkAuthStatus, user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!hasCheckedAuth) {
      void checkAuthStatus();
    }
  }, [checkAuthStatus, hasCheckedAuth]);

  if (isLoading || !hasCheckedAuth) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const next = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }

  const canAccessAfterTrial =
    location.pathname.startsWith('/billing') ||
    location.pathname.startsWith('/profile');

  if (user?.trial?.requires_payment && !canAccessAfterTrial) {
    return <Navigate to="/billing?trial=expired" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
